<template>
  <div>
    <template v-if="listType">
      <template v-for="atItem in options">
        <div
          :key="atItem.id"
          class="subcategory"
          :class="{make: value && value.id === atItem.id}"
          @click="value = atItem"
        >
          <i
            class="subcategory-icon"
            :class="['icon-'+atItem.id]"
          />
          <span>{{ atItem.name }}</span>
          <div
            :class="{ hide: value && value.id === atItem.id }"
            class="arrow"
          >
            <i class="icon-arrow-r" />
          </div>
        </div>
      </template>
    </template>
    <select-primary-js
      v-else
      v-model="value"
      :placeholder="$t('filter.sort.label')"
      label="radius"
      :searchable="false"
      :options="options"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import filterMutations from '../../store/filters/filters.mutationlist';
import SortAds from './SortAds';
import SelectPrimaryJs from '../MainLeftFilters/SelectPrimaryJs';

export default {
  components: { SelectPrimaryJs },
  extends: SortAds,
  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    listType: {},

    hasPrice: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      sort: state => state.filters.sort,
    }),
    value: {
      get() {
        return this.options.find(item => item.id === this.sort);
      },
      set(value) {
        this.sortBy(value.id);
        this.$emit('input', value);
      },
    },
    options () {
      return [
        { id: 'newest', name: this.$t('sort.newest.text') },
        ...(this.hasPrice ? [
          { id: 'price_low', name: this.$t('sort.lowest-price.text') },
          { id: 'price_high', name: this.$t('sort.highest-price.text') },
        ] : []),
        { id: 'oldest', name: this.$t('sort.oldest.text') },
      ]
    }
  },
  methods: {
    sortBy(type) {
      this.$store.commit(filterMutations.FILTER_SET, { key: 'sort', value: type });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Ads/SortAdsDropdown.vue